import { deleteQwanta } from './api-client';

export async function deleteInstance(recordId) {
    try {
        await deleteQwanta(recordId);
        console.log(`Record with ID ${recordId} deleted successfully.`);
    } catch (error) {
        console.error(`Error deleting record with ID ${recordId}:`, error);
        throw error;
    }
}